import {
  SET_LIST_MODULE_DATA,
  SET_LIST_MODULE_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listModuleData: null,
  listModuleDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_MODULE_DATA:
      return {
        ...state,
        loading: false,
        listModuleData: action.listModuleData,
      };

    case SET_LIST_MODULE_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listModuleDataTotal: action.listModuleDataTotal,
      };

    default:
      return { ...state };
  }
};
